import { CertificateCategory } from '@app/shared/models/certificate-category.model'
import { CertificateContractDetailsForm } from '@features/certificate/models/certificate-contract-details/certificate-contract-details.model'

/**
 * Visibility configuration for Certificate Contract Details based on Certificate Category.
 * This map defines which categories are allowed to see each field.
 */
export const CERTIFICATE_CONTRACT_DETAILS_VISIBILITY: Partial<Record<keyof CertificateContractDetailsForm, CertificateCategory[]>> = {
  furtherInsured: [CertificateCategory.AUTHORITIES, CertificateCategory.CONTRACTUAL, CertificateCategory.LEASE],
  contractParties: [CertificateCategory.AUTHORITIES, CertificateCategory.CONTRACTUAL, CertificateCategory.LEASE, CertificateCategory.LSG],
  contracts: [CertificateCategory.AUTHORITIES, CertificateCategory.CONTRACTUAL, CertificateCategory.LEASE, CertificateCategory.LSG],
  avn67B: [CertificateCategory.AUTHORITIES, CertificateCategory.LEASE],
  avn67C: [CertificateCategory.AUTHORITIES, CertificateCategory.LEASE],
  designatedContractParty: [CertificateCategory.AUTHORITIES, CertificateCategory.LEASE],
}
